import * as React from "react";

import { VendorContext } from "./VendorProvider";

const useVendorContext = () => {
  return React.useContext(VendorContext);
};

export default useVendorContext;
